// Generated by Melange

import * as Buhta_landing__Api from "../../../../core/Api.js";
import * as Buhta_landing__ButtonSecondary from "../../../../components/landing/ButtonSecondary.js";
import * as Buhta_landing__Content from "../../../../core/Content.js";
import * as Buhta_landing__I18n from "../../../../util/i18n/I18n.js";
import * as Buhta_landing__Link from "../../../../components/html/Link.js";
import * as Buhta_landing__Prices from "./Prices.js";
import * as Buhta_landing__Route from "../../../../Route.js";
import * as Buhta_models__Locale from "../../../../../../../packages/models/Locale.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function Pricing(Props) {
  const country = Buhta_landing__Route.getCountry(undefined);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const languageStr = Buhta_models__Locale.toString(language);
  const intl = ReactIntl.useIntl();
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const dispatchContent = match[1];
  const pricingPage = match[0].pricingPage;
  React.useEffect((function () {
    const __x = $$Promise.all({
      hd: Buhta_landing__Api.aboutPage(languageStr),
      tl: {
        hd: Buhta_landing__Api.pricingPage(languageStr),
        tl: /* [] */ 0
      }
    });
    $$Promise.get(__x, (function (respList) {
      Stdlib__List.iter((function (res) {
        Buhta_landing__Api.handleResponse(res, dispatchContent, undefined);
      }), respList);
    }));
  }), [language]);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h2", {
        children: pricingPage.title,
        className: "h4 lg:h2 text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: pricingPage.subtitle,
        className: "paragraph text-black-landing mt-2"
      }),
      country === /* COUNTRY_KAZ */ 1 ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("img", {
                    className: "max-w-none",
                    alt: "buhta",
                    src: StaticAsset.src("/static/icons/avatar-cashier-light-blue.svg")
                  })
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("h6", {
                      children: "Услуги по ККМ",
                      className: "h6 text-white"
                    }),
                    JsxRuntime.jsx("p", {
                      children: "Стоимость использования ККМ Бухта 1.0",
                      className: "paragraph text-white/64"
                    })
                  ],
                  className: "mt-4 lg:mt-0 lg:ml-4"
                })
              ],
              className: "block lg:flex items-center mb-6 lg:mb-10"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("p", {
                  children: "Для крупной площадки",
                  className: "paragraph-medium text-white"
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                      children: "100 000 ₸",
                      className: "paragraph text-secondary"
                    }),
                    JsxRuntime.jsx("p", {
                      children: "/мес",
                      className: "paragraph text-secondary/64"
                    })
                  ],
                  className: "flex"
                })
              ],
              className: "flex justify-between items-center mt-10"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  className: "w-4 h-4 translate-y-1",
                  src: StaticAsset.src("/static/icons/check-secondary.svg")
                }),
                JsxRuntime.jsx("p", {
                  children: "Расширенные возможности, разработанные специально для крупных компаний и маркетплейсов;",
                  className: "paragraph text-white"
                })
              ],
              className: "opacity-64 mt-4 flex gap-2"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  className: "w-4 h-4 translate-y-1",
                  src: StaticAsset.src("/static/icons/check-secondary.svg")
                }),
                JsxRuntime.jsx("p", {
                  children: "Интеграция через API и с пропускной возможностью выбивать неограниченное количество чеков в день",
                  className: "paragraph text-white"
                })
              ],
              className: "opacity-64 mt-2 flex gap-2"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("p", {
                  children: "Для любого сервиса",
                  className: "paragraph-medium text-white"
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                      children: "30 000 ₸",
                      className: "paragraph text-secondary"
                    }),
                    JsxRuntime.jsx("p", {
                      children: "/мес",
                      className: "paragraph text-secondary/64"
                    })
                  ],
                  className: "flex"
                })
              ],
              className: "flex justify-between items-center mt-10"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  className: "w-4 h-4 translate-y-1",
                  src: StaticAsset.src("/static/icons/check-secondary.svg")
                }),
                JsxRuntime.jsx("p", {
                  children: "Интеграция через API и с пропускной возможностью выбивать неограниченное количество чеков в день",
                  className: "paragraph text-white"
                })
              ],
              className: "opacity-64 mt-4 flex gap-2"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("p", {
                  children: "Для продавца на площадках",
                  className: "paragraph-medium text-white"
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                      children: "10 000 ₸",
                      className: "paragraph text-secondary"
                    }),
                    JsxRuntime.jsx("p", {
                      children: "/мес",
                      className: "paragraph text-secondary/64"
                    })
                  ],
                  className: "flex"
                })
              ],
              className: "flex justify-between items-center mt-10"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  className: "w-4 h-4 translate-y-1",
                  src: StaticAsset.src("/static/icons/check-secondary.svg")
                }),
                JsxRuntime.jsx("p", {
                  children: "Предназначена для мерчантов, которые работают на маркет-плейсах",
                  className: "paragraph text-white"
                })
              ],
              className: "opacity-64 mt-4 flex gap-2"
            }),
            JsxRuntime.jsx("hr", {
              className: "text-white opacity-16 mt-6 lg:mt-10"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Buhta_landing__ButtonSecondary.make, {
                classes: {
                  hd: "h-13 mt-4 lg:mt-0",
                  tl: /* [] */ 0
                },
                label: Buhta_landing__I18n.trans(intl, "start_using"),
                route: {
                  TAG: /* Landing */ 0,
                  _0: country,
                  _1: language,
                  _2: /* ContactForm */ 6
                }
              }),
              className: "mt-4 lg:mt-10 flex flex-col lg:flex-row justify-end"
            })
          ],
          className: "bg-primary-variant rounded-lg shadow-price p-6 lg:p-10 mt-6 lg:mt-10"
        }) : JsxRuntime.jsx("div", {
          className: "mt-6 lg:mt-10"
        }),
      JsxRuntime.jsx(Buhta_landing__Prices.make, {}),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h6", {
            children: pricingPage.card_title_2,
            className: "h6 text-gray-light-landing"
          }),
          JsxRuntime.jsx("p", {
            children: pricingPage.card_subtitle_2,
            className: "paragraph text-gray-light-landing opacity-64"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    src: StaticAsset.src("/static/icons/glovo-gray.svg")
                  }),
                  JsxRuntime.jsx("img", {
                    src: StaticAsset.src("/static/icons/yandex-gray.svg")
                  })
                ],
                className: "flex m-auto"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    src: StaticAsset.src("/static/icons/jusan-gray.svg")
                  }),
                  JsxRuntime.jsx("img", {
                    src: StaticAsset.src("/static/icons/indriver-gray.svg")
                  })
                ],
                className: "flex m-auto mt-2 lg:mt-auto"
              })
            ],
            className: "mt-6 lg:mt-10 block lg:flex"
          }),
          JsxRuntime.jsxs(Buhta_landing__Link.make, {
            route: {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: /* ContactForm */ 6
            },
            className: "block paragraph cursor-pointer link-hover text-secondary mt-6 lg:mt-10",
            children: [
              Buhta_landing__I18n.trans(intl, "contact_us"),
              JsxRuntime.jsx("img", {
                className: "inline ml-1",
                src: StaticAsset.src("/static/icons/forward-light-blue.svg")
              })
            ]
          })
        ],
        className: "bg-black-landing rounded-lg shadow-price p-6 lg:p-10 mt-4"
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-6 lg:mt-10"
      }),
      JsxRuntime.jsxs("p", {
        children: [
          Buhta_landing__I18n.trans(intl, "for_cooperation_and_partnership_write_to"),
          JsxRuntime.jsx("a", {
            children: "hello@buhta.com",
            className: "text-primary underline",
            href: "mailto:hello@buhta.com"
          })
        ],
        className: "paragraph-small lg:paragraph text-black-landing mt-6 lg:mt-10"
      })
    ],
    className: "pt-10 lg:pt-0 px-6 sm:px-48 lg:px-0"
  });
}

const make = Pricing;

export {
  make,
}
/* Buhta_landing__Api Not a pure module */
